import PropTypes from 'prop-types';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { rootColorOptions } from 'src/locales/constant/rootColorOptions';

export const OptionsColorPreset = (props) => {
  const { onChange, value } = props;

  const root = document.querySelector(':root');

  const applyChange = (option) => {
    onChange?.(option.value)
    root.style.setProperty('--main-color', option.color);
    root.style.setProperty('--light-color', option.lightColor);
    root.style.setProperty('--dark-color', option.darkColor);
    root.style.setProperty('--darkest-color', option.darkestColor);
  }

  return (
    <Stack spacing={1}>
      <Typography
        color="text.secondary"
        variant="overline"
      >
        Primary Color
      </Typography>
      <Stack
        alignItems="center"
        direction="row"
        flexWrap="wrap"
        gap={2}
      >
        {rootColorOptions.map((option) => (
          <Chip
            icon={(
              <Box
                sx={{
                  backgroundColor: option.color,
                  borderRadius: '50%',
                  flexShrink: 0,
                  height: 24,
                  width: 24
                }}
              />
            )}
            key={option.value}
            label={option.label}
            onClick={() => applyChange(option)}
            sx={{
              borderColor: 'transparent',
              borderRadius: 1.5,
              borderStyle: 'solid',
              borderWidth: 2,
              ...(option.value === value && {
                borderColor: 'primary.main'
              })
            }}
          />
        ))}
      </Stack>
    </Stack>
  );
};

OptionsColorPreset.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.oneOf(['blue', 'green', 'indigo', 'purple', 'orange'])
};
